

export const CONSTANTS = {
    NOT_SHOW_HELP_STRING : 'NOW_SHOW_HELP'
};
